// "Add to calendar" on a student's confirmed booking (PA-4). Downloads the booking's calendar
// file: the session title, start, end and meeting link. A pending booking shows nothing here,
// because the meeting link is earned by confirmation and the file carries it.
import React from 'react';
import { Btn } from './index';
import { api } from '../lib/api';
import { BOOKING_STATUS } from '../lib/rebook';
import { palette, type } from '../design';

const FONT = "'Plus Jakarta Sans', sans-serif";

export const CALENDAR_FILE_NAME = 'ropida-session.ics';
const FAILED_MESSAGE = 'We could not download your calendar file. Check your connection and try again.';

export function calendarPath(bookingId) {
  return `/bookings/${encodeURIComponent(bookingId)}/calendar.ics`;
}

// The booking id the confirmation email's link names (`?calendar=<id>`), or null when it has none.
export function calendarIdFromHash(hash) {
  const text = String(hash ?? '');
  const q = text.indexOf('?');
  if (q === -1) return null;
  return new URLSearchParams(text.slice(q + 1)).get('calendar') || null;
}

// Download one booking's calendar file. Throws the api Error, with the server's reason in .data.
export function downloadCalendarFile(bookingId) {
  return api.download(calendarPath(bookingId), CALENDAR_FILE_NAME);
}

export function calendarErrorMessage(err) {
  return err?.data?.message || FAILED_MESSAGE;
}

export function AddToCalendarButton({ booking, size = 'sm' }) {
  const [downloading, setDownloading] = React.useState(false);
  const [error, setError] = React.useState(null);

  if (!booking || booking.status !== BOOKING_STATUS.CONFIRMED) return null;

  const onClick = async () => {
    setDownloading(true);
    setError(null);
    try {
      await downloadCalendarFile(booking.id);
    } catch (err) {
      setError(calendarErrorMessage(err));
    } finally {
      setDownloading(false);
    }
  };

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2, maxWidth: 260 }}>
      <Btn size={size} variant="ghost" onClick={onClick} disabled={downloading}>Add to calendar</Btn>
      {error && (
        <span role="alert" style={{ fontFamily: FONT, fontSize: type.label, color: palette.errorRed, textAlign: 'right', lineHeight: 1.5 }}>{error}</span>
      )}
    </span>
  );
}
